module.exports = __webpack_public_path__ + "static/media/commons.33e19200.jpg";